export interface TradeBrand {
  id: number;
  direction: 'import' | 'export';
  name: string;
  tagline: string;
  origin: string;
  origin_flag: string;
  destination: string;
  destination_flag: string;
  category: string;
  description: string;
  features: string[];
  image_url: string;
  icon: string;
  sort_order: number;
}

export const tradeBrands: TradeBrand[] = [
  {
    id: 1,
    direction: 'import',
    name: 'Vietnam Coffee Star',
    tagline: '베트남 No.1 인스턴트 커피',
    origin: '베트남',
    origin_flag: '🇻🇳',
    destination: '한국',
    destination_flag: '🇰🇷',
    category: '커피 / 음료',
    description:
      '1969년 설립, 달랏 고원 로부스타·아라비카 원두로 55년 전통을 이어온 베트남 최대 커피 브랜드. 모나루가 한국 공식 수입·유통을 전담합니다.',
    features: [
      '베트남 인스턴트 커피 시장점유율 1위',
      '55년 전통 · 달랏 고원 원두',
      '40개국 수출 글로벌 브랜드',
      '3in1 · 연유 아이스커피 · 스트롱 라인업',
    ],
    image_url:
      'https://static.readdy.ai/image/3946f031037e28555363a2e50b79cfcb/1ea4434d2f9d2f6933d2601a846fcb10.jpeg',
    icon: 'ri-cup-line',
    sort_order: 1,
  },
  {
    id: 2,
    direction: 'export',
    name: 'LUNÉ',
    tagline: '한국 프리미엄 스킨케어',
    origin: '한국',
    origin_flag: '🇰🇷',
    destination: '베트남',
    destination_flag: '🇻🇳',
    category: '화장품 / 스킨케어',
    description:
      '서울에서 탄생한 클린 뷰티 브랜드 LUNÉ. 히알루론산·쌀 발효 성분 기반 저자극 라인이 베트남 MZ세대 사이에서 빠르게 확산되고 있으며, 모나루가 베트남 전국 유통을 담당합니다.',
    features: [
      '클린 뷰티 · 무파라벤 · 피부과 테스트 완료',
      '히알루론산 쌀 발효 에센스 시리즈',
      '베트남 호치민·하노이 주요 드럭스토어 입점',
      '한국 수출 화장품 베트남 인허가 완료',
    ],
    image_url:
      'https://public.readdy.ai/ai/img_res/fffc7ff90b9510fa1c0525ce81951106.jpg',
    icon: 'ri-drop-line',
    sort_order: 2,
  },
];

// Keep legacy export for compatibility
export interface ImportBrand {
  id: number;
  name: string;
  tagline: string;
  origin: string;
  originFlag: string;
  category: string;
  established: string;
  description: string;
  highlights: string[];
  products: {
    id: number;
    name: string;
    desc: string;
    imageUrl: string;
  }[];
  heroImageUrl: string;
  logoImageUrl: string;
  accentColor: string;
}

export const importBrands: ImportBrand[] = [
  {
    id: 1,
    name: 'VINACAFE',
    tagline: '베트남 No.1 커피 브랜드',
    origin: '베트남',
    originFlag: '🇻🇳',
    category: '커피 / 음료',
    established: '1969',
    description:
      '1969년 베트남에서 설립된 VINACAFE는 55년 전통의 베트남 최대 인스턴트 커피 브랜드입니다. 달랏(Da Lat) 고원의 아라비카와 로부스타 원두를 블렌딩하여 깊고 진한 베트남 특유의 커피 풍미를 완성합니다. 현재 전 세계 40여 개국에 수출되며, 모나루가 한국 공식 수입·유통을 담당합니다.',
    highlights: [
      '베트남 인스턴트 커피 시장점유율 1위',
      '55년 전통 · 달랏 고원 원두',
      '40개국 수출 글로벌 브랜드',
      '한국 독점 수입 공식 파트너',
    ],
    products: [
      {
        id: 1,
        name: 'VINACAFE 3in1 Original',
        desc: '진한 로부스타 원두에 크리머와 설탕을 최적 배합한 대표 제품.',
        imageUrl:
          'https://readdy.ai/api/search-image?query=VINACAFE%20Vietnamese%20instant%20coffee%203in1%20sachet%20stick%20pack%20product%20photography%20flat%20lay%20clean%20minimal%20background%20warm%20cream%20beige%20tones%20coffee%20beans%20scattered%20around%20elegant%20packaging%20closeup%20professional%20food%20photography&width=600&height=480&seq=vina_p1&orientation=landscape',
      },
      {
        id: 2,
        name: 'VINACAFE Wake Up Strong',
        desc: '두 배 진한 로부스타 블렌드. 강렬한 쓴맛과 풍부한 바디감.',
        imageUrl:
          'https://readdy.ai/api/search-image?query=strong%20dark%20Vietnamese%20drip%20coffee%20black%20americano%20ceramic%20cup%20overhead%20shot%20minimal%20white%20marble%20surface%20coffee%20beans%20professional%20product%20photography%20moody%20dark%20tones%20warm%20ambiance%20morning%20light&width=600&height=480&seq=vina_p2&orientation=landscape',
      },
      {
        id: 3,
        name: 'VINACAFE Café Pho',
        desc: '전통 베트남 연유 아이스커피 스타일. 연유의 달콤함과 차가운 원두의 균형.',
        imageUrl:
          'https://readdy.ai/api/search-image?query=Vietnamese%20iced%20coffee%20ca%20phe%20sua%20da%20glass%20with%20condensed%20milk%20layered%20drip%20filter%20traditional%20style%20wooden%20table%20tropical%20light%20warm%20golden%20tones%20beautiful%20food%20photography%20professional&width=600&height=480&seq=vina_p3&orientation=landscape',
      },
    ],
    heroImageUrl:
      'https://readdy.ai/api/search-image?query=lush%20green%20Vietnamese%20highland%20coffee%20plantation%20Da%20Lat%20mountains%20misty%20morning%20sunlight%20aerial%20panoramic%20view%20rows%20of%20coffee%20trees%20dramatic%20landscape%20fog%20valleys%20serene%20natural%20beauty%20Southeast%20Asia%20agricultural&width=1400&height=700&seq=vina_hero1&orientation=landscape',
    logoImageUrl:
      'https://readdy.ai/api/search-image?query=premium%20Vietnamese%20coffee%20brand%20packaging%20collection%20VINACAFE%20red%20gold%20color%20scheme%20instant%20coffee%20sachets%20box%20display%20product%20lineup%20clean%20white%20studio%20background%20professional%20commercial%20photography&width=800&height=600&seq=vina_logo1&orientation=landscape',
    accentColor: '#C8102E',
  },
];
